import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { TabularTypeDataset } from './tabular-type.dataset';
import { IModel } from '../base/annotation';

import { format } from 'app/shared/utils/string.util';
import { CommonDataServiceLinkedService } from '../linkedservice/common-data-service.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.commonDataService.datasetType,
    display: [format(stringResources.ModelName_DatasetTemplate, stringResources.CommonDataService_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.CommonDataService_DisplayText)],
        constraints: {
            linkedService: {
                model: CommonDataServiceLinkedService.MODEL // Linked service redefined
            }
        }
})
export class CommonDataServiceEntityDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
